import React from 'react';
import type { LuggageType } from 'src/components/Luggage/types';
import styled from 'styled-components';
import WeightLabel from './FlightsWeightLabel';
import { getIcon } from './utils';

interface FlightsLuggageIconProps {
  weight?: number;
  count?: number;
  type: LuggageType;
}

const FlightsLuggageIconWithLabel = ({
  weight,
  count,
  type,
}: FlightsLuggageIconProps) => {
  const baggageUnknown = count === undefined;
  const noBaggage = count === 0;
  const weightUnknown = Boolean(count) && !weight;

  return (
    <IconContainer $baggageUnknown={baggageUnknown} $noBaggage={noBaggage}>
      {getIcon({ type, weightUnknown, noBaggage })}
      <WeightLabel
        type={type}
        weight={weight}
        baggageUnknown={baggageUnknown}
        noBaggage={noBaggage}
        weightUnknown={weightUnknown}
      />
    </IconContainer>
  );
};

const IconContainer = styled.div<{
  $baggageUnknown: boolean;
  $noBaggage: boolean;
}>`
  display: flex;
  position: relative;
  height: 24px;
  width: 24px;

  & + & {
    margin-left: -4px;
  }

  > svg {
    position: absolute;

    > path {
      stroke: ${({ $baggageUnknown, $noBaggage }) =>
        !$baggageUnknown && !$noBaggage ? `#45BD81` : `#919499`};
    }
  }
`;

export default FlightsLuggageIconWithLabel;
